<template>

  <div id="app">
    <el-container id="root-container">
      <el-affix style="width:100%" >
        <the-header-menu-3 />
      </el-affix>
      <the-opening id="uvod" class="router-url" /> 
      <co-nabizime id="sluzby" class="router-url" />
      <vyhlidkove-lety id="vyhlidkovelety" class="router-url" />
      <pilotni-vycvik id="vycvik" class="router-url" />
      <historie id="historie" class="router-url"/>
      <pro-piloty id="propiloty" class="router-url" />
      <the-partners id="partneri" class="router-url" />
      <the-footer />
    </el-container>
  </div>

</template>

<script>

import TheHeaderMenu3 from '../components/TheHeaderMenu3.vue'
import TheOpening from '../components/TheOpening.vue'
import CoNabizime from '../components/CoNabizime.vue'
import VyhlidkoveLety from '../components/VyhlidkoveLety.vue'
import PilotniVycvik from '../components/PilotniVycvik.vue'
import Historie from '../components/Historie.vue'
import ProPiloty from '../components/TheProPiloty.vue'
import TheFooter from '../components/TheFooter.vue'
import ThePartners from '../components/ThePartners.vue'


export default {
  name: 'App',
  components: {
    TheHeaderMenu3,
    TheOpening,
    TheFooter,
    CoNabizime,
    VyhlidkoveLety,
    PilotniVycvik,
    Historie,
    ProPiloty,
    ThePartners
  },
}

</script>

<style lang="scss">

.top-navbar{
  background: #2c3e50;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  
}
#root-container{
  flex-direction: column;
  align-items: center;
}
.main-content{
  align-self: center;
  max-width: 900px;
  text-align: justify;
}
.vystrahy{
  top: 100px;
}

.warning-wrapper-main{
  position: fixed;
  bottom: 50px;
  z-index: 1000;
  width: 1285px;
  max-width: 90vw;
  margin: auto;

}

</style>
